import { render, staticRenderFns } from "./EvaluationButton.vue?vue&type=template&id=dfc45352&scoped=true"
import script from "./EvaluationButton.vue?vue&type=script&lang=ts"
export * from "./EvaluationButton.vue?vue&type=script&lang=ts"
import style0 from "./EvaluationButton.vue?vue&type=style&index=0&id=dfc45352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc45352",
  null
  
)

export default component.exports